export const PRICE_ON_REQUEST_MAX = 0.01;

export const isPriceOnRequest = (price) => {
  const amount = Number(price || 0);
  return !Number.isFinite(amount) || amount <= PRICE_ON_REQUEST_MAX + Number.EPSILON;
};
